<template>
  <v-container>
      <v-tabs align-with-title v-model="tab" class="mt-15 d-flex justify-center">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab>
          To Delivery
        </v-tab>
        <v-tab>
          Delivered           
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" touchless>
        <v-tab-item>          
          <v-row v-if ="isAdmin" class="mt-1"  justify="center" >          
            <v-autocomplete
              clearable
              label="Employee name"
              :items="employees"
              variant="outlined"
              item-value="EMPMST_DOCNO"
              item-text="EMPMST_NAME"
              v-model="selectedEmployee"
              @change="fetchPdf()"
            ></v-autocomplete>         
          </v-row>
          <v-card flat>                   
            <GmapMap
              :center= "startLocation"
              :zoom="12"
              style="width: 100%; height: 500px;"
              :options="{mapTypeId: 'roadmap',streetViewControl: false}"
              ref="map"
            >
              <!-- Map markers for waypoints -->
              <GmapMarker
                v-for="(waypoint, index) in waypoints"
                :key="waypoint.id"
                :position="waypoint.location"
                :clickable="true"
                :draggable="false"
                :label="waypoint.label"
                :icon="colors[waypoint.type]"
                @dragend="onMarkerDragEnd(index)"
              />
            </GmapMap>   
          </v-card>
          <v-row>
            <v-col cols="4" sm="4" md="4">
            <v-checkbox
                v-model="isOptimizeWaypoints"
                label="Optimize waypoints"
            />
            </v-col>
            <v-col cols="4" sm="4" md="4" >
              <div class="grey--text text-darken-1 mb-2 mt-10">
                <v-btn  @click="calculateDirections"
                  prepend-icon="mdi-call-split"
                  class="ma-2"
                  color="primary"
                  stacked
                  variant="outlined"
                >
                  Start
                 
                </v-btn>
                <!-- <v-btn @click="calculateDirections" icon="mdi-call-split">                  
                  start</v-btn> -->
              </div>
            </v-col>
            
          <v-col cols="4" sm="4" md="4" >
            <a :href="generateGoogleMapsLink()" target="_blank" >
              Google Maps
              <v-icon class="material-icons">
                mdi-open-in-new
              </v-icon>              
            </a>
          </v-col>          
        </v-row>
        <!-- Add button for marking delivery as complete -->
        <v-btn @click="markComplete(waypoint)">Mark as Complete</v-btn>
        <!-- <BarcodeScanner @scanned="handleScan" /> -->

        <!-- Add QrCode scanner -->
        <!-- <qrcode-stream @decode="onDecode"></qrcode-stream> -->
        <v-btn @click="toggleQrReader">Toggle QR Reader</v-btn>
        <qrcode-stream v-if="showQrReader" @decode="onDecode"></qrcode-stream>

        <!-- Add timeline -->
        <!-- <timeline :items="timelineItems"></timeline> -->
        <v-btn @click="toggleTimelineOrientation">Toggle Timeline Orientation</v-btn>
        <timeline v-if="isHorizontal" :items="timelineItems">
         <!-- Add button for marking delivery as complete -->
        
        </timeline>
        <timeline-item v-for="item in timelineItems" :key="item" v-else>
          <h1 slot="title">{{ item.title }}</h1>
          <p slot="content">{{ item.content }}</p>
          <v-btn @click="markComplete(item)">Mark as Complete</v-btn>
        </timeline-item>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-text>Check-out portion</v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>  
  </v-container>   
  </template>
    
  <script>
  import { gmapApi } from 'vue2-google-maps'
  import { QrcodeStream } from 'vue-qrcode-reader'
  import Timeline from 'vue-horizontal-timeline'
  import { TimelineItem } from 'vue-simple-timeline'
  // import BarcodeScanner from '@/components/BarcodeScanner.vue';
  export default {
    components: {
      QrcodeStream,
      Timeline,
      TimelineItem,
      // BarcodeScanner,
    },
    data() {
      return {
        tab: null,
        center: { lat: 25.51563, lng: 55.67009 }, 
        zoom: 10, 
        isOptimizeWaypoints: true,
        waypoints: [
          {
            id: 1,
            location: { lat: 25.47257, lng: 55.60219 },
            label: 'Waypoint a',
            priority: 2,
            type: 'delivery',
          },
          {
            id: 2,
            location: { lat: 25.38693, lng: 55.49024 },
            label: 'Waypoint b',
            priority: 1,
            type: 'pickup',
          },
          {
            id: 3,
            location: { lat: 25.68390, lng: 55.85239 },
            label: 'Waypoint c',
            priority: 3,
            type: 'both'
          }
        ],
        colors: {
          delivery: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png',
          pickup: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png',
          both: 'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png'
        }, 
        directions: null,
        directionsOptions: {
          suppressMarkers: true,
          polylineOptions: {
            strokeColor: '#FF0000',
            strokeOpacity: 0.8,
            strokeWeight: 5
          }
        },
        completed: false,
        showQrReader: false,
        isHorizontal: true,
          
      };
    },
    computed:{  
      google: gmapApi,
      isAdmin(){
        if(this.$store.getters.fbuserdata.usertype == 1)
          return true;
        else
          return false;
      },         
      startLocation() {
        const { latitude, longitude } = this.$store.getters.myLocation;
        return {
          lat: latitude,
          lng: longitude
        };
      },
      endLocation() {
        return this.$store.getters.tgtLocation;
      },
      distBtw() {
        return this.$store.getters.distBtw;
      },
      waypnt(){
        return this.$store.getters.myLocation;
      },       
      timelineItems() {
        return this.waypoints.map(waypoint => ({
          title: `Delivery ${waypoint.id}`,
          content: waypoint.completed ? 'Completed' : 'Not yet completed'
        }));
      },      
    },
    methods: {
      onMarkerDragEnd (index) {
        this.waypoints[index].location = {
          lat: this.$refs.map.$mapObject.markers[index].position.lat(),
          lng: this.$refs.map.$mapObject.markers[index].position.lng()
        }
        this.calculateDirections()
      },
      calculateDirections () {
        const directionsService = new this.google.maps.DirectionsService();
        const map = this.$refs.map.$mapObject; // Get the underlying Google Map instance
        const directionsRenderer = new this.google.maps.DirectionsRenderer();
        directionsRenderer.setMap(map);

        let waypoints = this.waypoints.map(waypoint => ({
          location: waypoint.location,
          stopover: true
        }));
        if (!this.isOptimizeWaypoints) {
          waypoints = waypoints.sort((a, b) => a.priority - b.priority);
        }
        directionsService.route(
          {
            origin: this.startLocation,
            destination: waypoints[waypoints.length - 1].location,
            waypoints: waypoints.slice(1, -1),
            optimizeWaypoints: this.isOptimizeWaypoints,
            travelMode: this.google.maps.TravelMode.DRIVING,
          },
          (response, status) => {
            if (status === this.google.maps.DirectionsStatus.OK) {
              directionsRenderer.setDirections(response);              
            } else {
              console.error(`Failed to get directions: ${status}`);
            }
          }
        );
      },
      generateGoogleMapsLink() {
        let baseUrl = "https://www.google.com/maps/dir/";
        let locations = this.waypoints.map(waypoint => `${waypoint.location.lat},${waypoint.location.lng}`).join('/');
        return baseUrl + locations;
      },
      getIconForWaypoint(waypoint) {
        if (waypoint.type === 'delivery') {
          return '/path/to/delivery/icon.png';
        } else if (waypoint.type === 'pickup') {
          return '/path/to/pickup/icon.png';
        } else {
          return '/path/to/both/icon.png';
        }
      },
      toggleQrReader() {
        return this.showQrReader = !this.showQrReader;
      },
      // Add method for QrCode decoding
      onDecode(content) {
        alert(content)
        console.log(content); // This will be the content of the QR code
      },  
      // Add method for marking delivery as complete
      markComplete(waypoint) {
        waypoint.completed = true;
        // Make a request to your server to save this data
      },
      // Add method for sending data with Socket.IO
      // sendUpdate() {
      //   this.$socket.emit('update', {
      //     location: this.myLocation,
      //     directions: this.directions
      //   });
      // },
      // // Add method for calculating ETA using Google Maps Distance Matrix API
      // calculateETA(startLocation, destinationLocation) {
      //   const service = this.google.maps.DistanceMatrixService();

      //   service.getDistanceMatrix({
      //     origins: [startLocation],
      //     destinations: [destinationLocation],
      //     travelMode: this.google.maps.TravelMode.DRIVING
      //   }, (response, status) => {
      //     if (status === this.google.maps.DistanceMatrixStatus.OK) {
      //       const travelTime = response.rows[0].elements[0].duration.text;
      //       console.log(travelTime);
      //     }
      //   });
      // } ,
      toggleTimelineOrientation() {
        this.isHorizontal = !this.isHorizontal;
      },
      handleScan(barcode) {
      console.log(barcode);
      // handle the scanned barcode
      alert(barcode)
    }     
    },
    mounted() {
      this.$store.dispatch("fetchOrders");
      // this.$nextTick(() => {
      //   this.calculateDirections()
      // })
    }
  }
  </script>
  